/*
首页接口
*/ 
import { axios } from '@/utils/http'

// 正在热映 8.0
export const getHitFilm = (params) => axios({
  method: 'post',
  data: {
    ...params
  },
  noToast: true
}, '/cbticket/cticket/getHitFilm')

// 即将上映 8.0
export const getUpcomingFilm = (params) => axios({
  method: 'post',
  data: {
    ...params
  },
  noToast: true
}, '/cbticket/cticket/getUpcomingFilm')

// c8.0 影院详情
export const getCinemaDetail = (params) => axios({
  method: 'post',
  data: {
    ...params
  }
}, '/cbticket/cbase/getCinemaDetail')

// C8.0 影片详情
export const getFilmDetail = (params) => axios({
  method: 'post',
  data: {
    ...params
  }
}, '/cbticket/cbase/getFilmDetail')

// 轮播图接口 8.0
export const getDistribution = (params) => axios({
  method: 'post',
  data: {
    ...params
  }
}, '/capp/ad/distribution')

// feed流接口 8.0/app/feed/list
export const getFeedList = (params) => axios({
  method: 'post',
  contentType: 'json',
  data: {
    ...params
  }
}, '/capp/app/feed/list')

// 获取影片或影城评论
export const comment = (params) => axios({
  method: 'post',
  data: {
    ...params
  }
}, '/capp/cmt/list')

// 添加评论
export const addComment = (params) => axios({
  method: 'post',
  data: {
    ...params
  }
}, '/capp/cmt/comment')

// 活动详情 
export const getRuleDetail = (params) => axios({
  method: 'post',
  data: {
    ...params
  }
}, '/marketing/cActivity/rule/view')

// 资讯详情 
export const queryInfoDetail = (params) => axios({
  method: 'post',
  data: {
    ...params
  }
}, '/capp/information/queryInfo')

//资讯点赞
export const liked = (params) => axios({
  method: 'post',
  data: {
    ...params
  }
}, '/capp/information/liked')

//资讯下载图片
export const downloadImg = (params) => axios({
  method: 'post',
  data: {
    ...params
  },
  responseType: 'blob'
  // contentType: 'blob'
}, '/capp/share/image')

// 咨询轮播接口 /capp/informationHw/list
export const homenewslist = (params) => axios({
  method: 'post',
  data: {
    ...params
  }
}, '/capp/informationHw/list')

// 咨询轮播接口 /capp/informationHw/list
export const foot = (params) => axios({
  method: 'post',
  data: {
    ...params
  }
}, '/capp/informationHw/queryInfoHwType')


// WEBPACK FOOTER //
// ./src/api/home/home.js